export const validateImageTypes = (file: File) => {
  const validTypes = ["image/jpeg", "image/png", "image/gif"];
  const maxSize = 2 * 1024 * 1024; // 2 MB
  return validTypes.includes(file.type) && file.size <= maxSize;
};
